import React, { useState } from "react";
import { formatDateForRecentDevelopments } from "../../../services/commonService";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomModal from "../../HtmlElements/CustomModal";

export default function RecentDevelopments({numOfDevelopments, recentDevelopmentsData}) {
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [nthDev, setNthDev] = useState(0);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);  // You can adjust the number of items per page

  numOfDevelopments = numOfDevelopments == 8? 300 : numOfDevelopments;

  const renderTooltip = (title, use_case_text) => (
    <Tooltip className="custom-use-case-tooltip"> <b>{title} : </b> {use_case_text}</Tooltip>
  );

  const handleMore = (newindex) => {
    // let userStat = getUserStatsObject("Competitors", "select", "Data: "+keyCompetitors[newindex]?.name+", Page Source:<Account Name>", currentUrl);
    // recordActivity(userStat);
    setShowMoreModal(true);
    setNthDev(newindex);
  };

  const handleClose = () => {
    setShowMoreModal(false);
    setNthDev(0);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDevelopments = recentDevelopmentsData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => setCurrentPage((prev) => prev + 1);
  const prevPage = () => setCurrentPage((prev) => prev - 1);

  // Go to first page
  const goToFirstPage = () => setCurrentPage(1);

  // Go to last page
  const goToLastPage = () => setCurrentPage(totalPages);

  // Total number of pages
  const totalPages = Math.ceil(recentDevelopmentsData.length / itemsPerPage);

  // Pagination range (show 3 page numbers at a time)
  const getPageRange = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 1); // Start from the previous page, or 1 if at the beginning
    const endPage = Math.min(totalPages, currentPage + 1); // Show the next 2 pages, or the total pages if close to the end

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  // Calculate start and end items shown
  const startItem = indexOfFirstItem + 1;
  const endItem = indexOfLastItem > recentDevelopmentsData.length ? recentDevelopmentsData.length : indexOfLastItem;


  return (
    <>
      <div className="custom_card_block">
        <div className="recent_dev_wrapper">
          <div className="head_top">
            <h5 className="main_head">
              Key Developments <span className="plus_number">({(numOfDevelopments)})</span>
            </h5>
            <div className="high_impact">High Impact <div className="icon_block">
                      <img src="/img/fire.png" className="fire_icon" alt="icon" />
                    </div></div>
          </div>
          <div className="row">

            {currentDevelopments.map((development, index) => {
                return <div className="col-md-3" key={index}>
                <div className="recent_dev_block">
                  <div className="recent_icon_head">
                    {development.is_trending == true && <div className="icon_block">
                      <img src="/img/fire.png" className="fire_icon" alt="icon" />
                    </div>
                    }

                    <div className="recent_head_block">
                      {/* <OverlayTrigger key={index} overlay={renderTooltip(development.type, development.headline)}> */}
                        <h5 className="recent_head">{development.type} </h5>
                      {/* </OverlayTrigger> */}
                    </div>
                  </div>
                  <div className="para_block">
                  {/* <OverlayTrigger key={index} overlay={renderTooltip(development.type, development.headline)}> */}
                    <p className="recent_dev_para mb-1">
                      {development.headline}
                    </p>
                    {/* </OverlayTrigger> */}
                    <p className="recent_date" title="">
                      {formatDateForRecentDevelopments(development.date)}
                    </p>

                    {(<p className='show_more' onClick={() => handleMore(index)}><i className="fa fa-ellipsis-h" aria-hidden="true"></i></p>)}

                  </div>
                </div>
              </div>
            })}
            
          </div>
          {/* Pagination Controls */}
          <div>
            <div className="pagination custom_pagination_whatsnew">
              <div className="total_div_block">
                <span className="total_dev">
                  Showing {startItem} to {endItem} of {recentDevelopmentsData.length}
                </span>
              </div>
              <div className="pagination_block">
                <button onClick={goToFirstPage} disabled={currentPage === 1} className="page-item">First</button>

                <div
                  className={`page-numbers ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                >
                  <button onClick={prevPage} disabled={currentPage === 1} className="pagination-page-btn">
                  <i className="fa fa-angle-left" aria-hidden="true"></i>
                  </button>
                </div>

                {/* Page Numbers */}
                <div className="page-numbers">
                  {getPageRange().map((page) => (
                    <button
                      key={page}
                      onClick={() => paginate(page)}
                      className={`pagination-page-btn ${currentPage === page ? 'active' : ''}`}
                    >
                      <span className="btn_span">{page}</span>
                    </button>
                  ))}
                </div>

                <div
                  className={`page-numbers ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button onClick={nextPage} disabled={currentPage === totalPages} className="pagination-page-btn">
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </div>
                <button onClick={goToLastPage} disabled={currentPage === totalPages} className="pagination-btn">Last</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showMoreModal && 
        <CustomModal 
          title={currentDevelopments[nthDev].headline}
          text={currentDevelopments[nthDev].situation}
          isTrending={currentDevelopments[nthDev].is_trending}
          date={currentDevelopments[nthDev].date}
          newType={currentDevelopments[nthDev].type}
          handleClose={handleClose} 
        />}
    </>
  );
}
